import { create } from 'zustand'

export type SandboxSource = 'sidebar' | 'mobile-banner'

interface SandboxDialogStore {
  isOpen: boolean
  source: SandboxSource | null
  openDialog: (source: SandboxSource) => void
  closeDialog: () => void
  setIsOpen: (open: boolean) => void
}

export const useSandboxDialogStore = create<SandboxDialogStore>((set) => ({
  isOpen: false,
  source: null,
  openDialog: (source: SandboxSource) => set({ isOpen: true, source }),
  closeDialog: () => set({ isOpen: false, source: null }),
  setIsOpen: (open: boolean) => set({ isOpen: open }),
}))
